import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=eff0f53c&scoped=true&"
import script from "./CurrencyField.vue?vue&type=script&lang=js&"
export * from "./CurrencyField.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyField.vue?vue&type=style&index=0&id=eff0f53c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff0f53c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
